module.exports = __webpack_public_path__ + "aeb2d58832c6dc501253d235d5467fe3.svg";